import Spinner from "@portal/components/atoms/v2/spinner";

const PageSpinner = () => (
  <div className="flex w-full justify-center my-20">
    <Spinner size="large" />
  </div>
);

export default PageSpinner;
